import { render, staticRenderFns } from "./X150.vue?vue&type=template&id=5c1347d7&scoped=true&lang=pug"
import script from "./X150.vue?vue&type=script&lang=js"
export * from "./X150.vue?vue&type=script&lang=js"
import style0 from "./X150.vue?vue&type=style&index=0&id=5c1347d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1347d7",
  null
  
)

export default component.exports